import { Box } from '@mui/material';
import { useContext } from 'react';

import { PanelVisibilityProvider } from '~/components/common/tabs/PanelVisibility';
import { TabContext } from '~/components/common/tabs/useTabs';

interface TabPanelProps {
  tabId: string;
  children?: React.ReactNode;
}

export default function TabPanel({ tabId, children }: TabPanelProps) {
  const { selectedTab } = useContext(TabContext);
  const isVisible = selectedTab === tabId;

  return (
    <Box
      role="tabpanel"
      id={tabId}
      display={isVisible ? 'flex' : 'none'}
      width="100%"
      aria-labelledby={tabId}
      // `minWidth: 0` lets the panel shrink to its container instead of being
      // stretched by wide content (a data grid), which would push the page wider
      // than the window.
      sx={{
        flex: '1 0 auto',
        minWidth: 0,
      }}
    >
      <PanelVisibilityProvider value={isVisible}>{children}</PanelVisibilityProvider>
    </Box>
  );
}
